import { FC } from 'react';
import logo from '../assets/large.jpg';
import classes from './header.module.css';

export const Header: FC = () => (
  <img src={logo} alt="Helder Accu Service Logo" className={classes.header} />
);
